import { ApiQueryParams } from '@frontend/api-utils';
import { AsyncComponent } from '@frontend/components/common';
import { MultiProductSelect } from '@frontend/product/select';
import { MultiUserSelect } from '@frontend/user/select';
import React from 'react';

interface Props<S> {
    id: string;
    objectKey: keyof S | string;
    submitted: boolean;
    required?: boolean;
    disabled?: boolean;
    useConditionedStyling?: boolean;
    isClearable?: boolean;
    label?: React.ReactNode;
    value?: string[];
    onChange?: (value: string[]) => void;
    fieldProps?: Map<keyof S, any>;
    queryParams?: ApiQueryParams<string | number>;
    className?: string;
    allowURLChange?: boolean;
    defaultValue?: string | null;
    hideLabel?: boolean;
    onBlur?: () => void;
    hidePlaceholder?: boolean;
    queryKeyOverride?: string;
}

const fallback = (
    <span className='placeholder-glow'>
        <span className='placeholder'>loading</span>
    </span>
);
export const MultiObjectSelectMapper = <S,>(props: Props<S>) => {
    switch (props.objectKey) {
        case 'senders':
        case 'receivers':
        case 'owners':
        case 'users':
            return (
                <AsyncComponent fallback={fallback}>
                    <MultiUserSelect
                        {...props}
                        {...props.fieldProps}
                    />
                </AsyncComponent>
            );
        case 'products':
            return (
                <AsyncComponent fallback={fallback}>
                    <MultiProductSelect
                        {...props}
                        {...props.fieldProps}
                    />
                </AsyncComponent>
            );
    }
    return <></>;
};
